import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Button, Card, CardBody, UncontrolledCollapse } from 'reactstrap';
import Header from '../../components/Header';
import Footer from '../../components/Footer';
import Menu from '../../components/Menu';
import BurgerMenu from '../../components/BurgerMenu';
import { ReactComponent as IconProfile } from '../../images/icn_attività.svg';
import { DataTable, Field, DateTimeField } from '../../components/DataTable';
import { ActivityTypeField } from '../../components/DataTableFields';
import ActivityModal from '../../components/ActivityButtonGroup/ActivityModal';
import Filters from '../../components/Filters';
import { FILTERS } from '../../constants/filters';

const Contact = ({ data }) => {
  const { contact_last_name = '', contact_first_name = '' } = data || {}
  return (
    <div>{contact_first_name} {contact_last_name}</div>
  )
}

function ActiivitiesPresentational({ activities, total, query = {}, onFilter, isLoading, onSaveActivity, isAdding = false, onDeleteActivity }) {
  const [t] = useTranslation('ACTIVITIES');
  const { offset } = query
  const [open, setOpen] = useState(false);
  const [activity, setActivity] = useState();

  const toggle = () => setOpen(!open);

  const openModal = (activity = {}) => {
    setActivity(activity)
    toggle()
  }

  return (
    <div className="App">
      <Menu />

      <div className="corpo">
        <section>
          <Header
            title={t('COMMON:ACTIVITIES')}
            icon={<IconProfile fill='#FF6B38' />}
          />

          <div className="row">
            <div className="col-6">
              <Button className="btn-collapse" id="toggler" style={{ marginBottom: '1rem' }}>
                {t('COMMON:FILTER_BY')} <i className="fas fa-filter"></i>
              </Button>
            </div>
          </div>

          <UncontrolledCollapse toggler="#toggler">
            <div className="m-t-20">
              <Filters
                query={query}
                onFilter={onFilter}
                list={[FILTERS.CONTACT_ID, FILTERS.COMPANY_ID, FILTERS.USER_ID]}
              />
            </div>
          </UncontrolledCollapse>

          <hr />

          <Card>
            <CardBody>
              <DataTable
                offset={offset}
                total={total}
                data={activities}
                isLoading={isLoading}
                loadingText={t('COMMON:LOADING')}
                emptyText={t('COMMON:NO_DATA')}
                onFilter={onFilter}
                onRowClick={openModal}
              >
                <Field title={t('COMMON:DESCRIPTION')} source="description" maxLength={40} />
                <ActivityTypeField title={t('TYPE')} source="type" />
                <Field title={t('COMMON:USER')} source="user_name" />
                <Contact title={t('CONTACT')} />
                <Field title={t('DEAL')} source="deal_name" />
                <DateTimeField title={t('DATE')} source="date" />
                <Field title={t('DONE')} source='done' />
              </DataTable>
            </CardBody>
          </Card>

          <ActivityModal
            activity={activity}
            open={open}
            toggle={toggle}
            onSubmit={(values) => {
              onSaveActivity({ values, type: activity.type, id: activity.id })
              toggle()
            }}
            onDeleteActivity={() => {
              onDeleteActivity(activity.id)
              toggle()
            }}
            type={activity && activity.type}
          />

        </section>
        <Footer />
      </div>
      <BurgerMenu />
    </div>
  );
}

export default ActiivitiesPresentational;
